import produce from 'immer';
import { IPaginatedStoreResource } from '../helpers/pagination';
import { initialRootState } from '../initialRootState';
import { EFavoritesActionType, IFavoritesAction } from './actions';

interface IFavoritesStore extends IPaginatedStoreResource {
  list: string[];
}

export interface IFavoritesState {
  received: IFavoritesStore;
  sent: IFavoritesStore;
  nbFavorites: number;
}

export const favoritesReducer = (
  currentState: IFavoritesState = initialRootState.favorites,
  action: IFavoritesAction
): IFavoritesState =>
  produce(currentState, draft => {
    switch (action.type) {
      // Post
      case EFavoritesActionType.INCREMENT_FAVORITES: {
        draft.nbFavorites += 1;
        break;
      }

      // Received
      case EFavoritesActionType.GET_RECEIVED_FAVORITES_SUCCESS: {
        const {
          meta: {
            pagination: { current_page: currentPage, total },
          },
          data,
        } = action.payload.result;

        draft.received.list = draft.received.list.concat(data);
        draft.received.meta = { currentPage, total };
        break;
      }
      case EFavoritesActionType.RESET_RECEIVED_FAVORITES:
        draft.received = initialRootState.favorites.received;
        break;

      // Sent
      case EFavoritesActionType.GET_SENT_FAVORITES_SUCCESS: {
        const {
          meta: {
            pagination: { current_page: currentPage, total },
          },
          data,
        } = action.payload.result;

        draft.sent.list = draft.sent.list.concat(data);
        draft.sent.meta = { currentPage, total };
        break;
      }
      case EFavoritesActionType.RESET_SENT_FAVORITES:
        draft.sent = initialRootState.favorites.sent;
        break;
      case EFavoritesActionType.POST_FAVORITE_SUCCESS:
        const totalSent = draft.sent.meta.total;

        if (action.payload.ratingStatus === 'yes') {
          draft.sent.list = [action.payload.accountId, ...draft.sent.list];
          draft.sent.meta.total = totalSent ? totalSent + 1 : 1;
        }
        break;
    }
  });
